module.exports = __webpack_public_path__ + "static/media/ppe_res_equ.a904f30e.png";